import {
  REQUEST_FETCH_PERMALINK_AD,
  FETCH_PERMALINK_AD_SUCCESS,
  FETCH_PERMALINK_AD_FAILURE,
  CLEAR_FETCH_PERMALINK_AD_STATES,
} from "./permalink.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const permalinkAdReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_PERMALINK_AD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PERMALINK_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };

    case FETCH_PERMALINK_AD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };

    case CLEAR_FETCH_PERMALINK_AD_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };

    default:
      return state;
  }
};

export default permalinkAdReducer;
